import { isHonorBrowser, isOppoBrowser } from "@/utils/misc"
import buildingA1Mov from "../../assets/img/lobby/buildings/A1.mov"
import buildingA1WebM from "../../assets/img/lobby/buildings/A1.webm"
import buildingA2Mov from "../../assets/img/lobby/buildings/A2.mov"
import buildingA2WebM from "../../assets/img/lobby/buildings/A2.webm"
import buildingA3Mov from "../../assets/img/lobby/buildings/A3.mov"
import buildingA3WebM from "../../assets/img/lobby/buildings/A3.webm"
import buildingA4Mov from "../../assets/img/lobby/buildings/A4.mov"
import buildingA4WebM from "../../assets/img/lobby/buildings/A4.webm"
import buildingA5Mov from "../../assets/img/lobby/buildings/A5.mov"
import buildingA5WebM from "../../assets/img/lobby/buildings/A5.webm"
import buildingA6Mov from "../../assets/img/lobby/buildings/A6.mov"
import buildingA6WebM from "../../assets/img/lobby/buildings/A6.webm"
import lobbyVideoMov from "../../assets/video/lobby.mov"
import lobbyVideoWebM from "../../assets/video/lobby.webm"
import { ESubPage } from "../../context"

import buildingA1Png from "../../assets/img/lobby/buildings/A1.png"
import buildingA2Png from "../../assets/img/lobby/buildings/A2.png"
import buildingA3Png from "../../assets/img/lobby/buildings/A3.png"
import buildingA4Png from "../../assets/img/lobby/buildings/A4.png"
import buildingA5Png from "../../assets/img/lobby/buildings/A5.png"
import buildingA6Png from "../../assets/img/lobby/buildings/A6.png"
import titleA1Png from "../../assets/img/lobby/title/A1.png"
import titleA2Png from "../../assets/img/lobby/title/A2.png"
import titleA3Png from "../../assets/img/lobby/title/A3.png"
import titleA4Png from "../../assets/img/lobby/title/A4.png"
import titleA5Png from "../../assets/img/lobby/title/A5.png"
import titleA6Png from "../../assets/img/lobby/title/A6.png"
import lobbyVideo from "../../assets/video/lobby.mp4"

function isSafari() {
    const ua = navigator.userAgent
    return /^((?!chrome|android).)*safari/i.test(ua)
}

function supportsVP9WebM() {
    const video = document.createElement("video")
    const basicSupport = window.MediaSource?.isTypeSupported(
        'video/webm; codecs="vp9"'
    )
    const playSupport =
        video.canPlayType('video/webm; codecs="vp9"') === "probably"
    return basicSupport && playSupport && !isSafari()
}
export const useStaticImage = isHonorBrowser() || isOppoBrowser()
export const useWebM = supportsVP9WebM() && !useStaticImage

export const backgroundVideo = {
    mp4: lobbyVideo,
    mov: lobbyVideoMov,
    webm: lobbyVideoWebM,
}

export const buildings = [
    {
        id: "A1",
        title: "subPage.game",
        type: ESubPage.Game,
        webm: buildingA1WebM,
        mov: buildingA1Mov,
        png: buildingA1Png,
        titleImg: titleA1Png,
        active: true,
    },
    {
        id: "A2",
        title: "subPage.enemy",
        type: ESubPage.Enemy,
        webm: buildingA2WebM,
        mov: buildingA2Mov,
        png: buildingA2Png,
        titleImg: titleA2Png,
        active: !__ROGUE_5_PRE,
    },
    {
        id: "A3",
        title: "subPage.sp",
        type: ESubPage.SP,
        webm: buildingA3WebM,
        mov: buildingA3Mov,
        png: buildingA3Png,
        titleImg: titleA3Png,
        active: !__ROGUE_5_PRE,
    },
    {
        id: "A4",
        title: "subPage.relic",
        type: ESubPage.Relic,
        webm: buildingA4WebM,
        mov: buildingA4Mov,
        png: buildingA4Png,
        titleImg: titleA4Png,
        active: !__ROGUE_5_PRE,
    },
    {
        id: "A5",
        title: "subPage.record",
        type: ESubPage.Record,
        webm: buildingA5WebM,
        mov: buildingA5Mov,
        png: buildingA5Png,
        titleImg: titleA5Png,
        active: !__ROGUE_5_PRE,
    },
    {
        id: "A6",
        title: "subPage.pv",
        type: ESubPage.PV,
        webm: buildingA6WebM,
        mov: buildingA6Mov,
        png: buildingA6Png,
        titleImg: titleA6Png,
        active: !__ROGUE_5_PRE,
    },
]
